'use strict';
import Swiper from 'swiper';

const $ = window.jQuery;

export default function () {

    const swiper = new Swiper('.join-us__slider-integrate .slider', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        loop: true,


        breakpoints: {
            // when window width is >= 767px
            /*767: {
                spaceBetween: 26,
            },*/
        }
    });

}
